import { useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";
import Loader from "../common/Loader";
import ErrorSuccessModal from "../common/modal/errorsuccessmodal";
import ConfirmBbps from "../common/modal/confirmbbps";

export default function WalletTransfer() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isErrorFlag, setIsErrorFlag] = useState(0);
  const [mobile, setMobile] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(0);
  const [showErrorSuccessModal, setShowErrorSuccessModal] = useState(0);
  const [modalMsg, setModalMsg] = useState("");

  const openConfirmModal = () => setShowConfirmPopUp(1);
  const closeConfirmModal = () => setShowConfirmPopUp(0);

  const openModal = (type) => {
    switch(type){
      case 'Error':
        setIsErrorFlag(1);
        setShowErrorSuccessModal(1);
      break;
      case 'Success':
        setIsErrorFlag(0);
        setShowErrorSuccessModal(1);
      break;
    }
  };
  const closeModal = (type) => {
    if(type === 'Success' || type === 'Error'){
      setIsErrorFlag(0);
      setShowErrorSuccessModal(0);
    }
  };

  const submitHandler = async() => {
    const newErrors = errorHandling('search');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("mobile_number", mobile);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/wallet-transfer-search', formData);
        if(response?.data?.status === 'success'){
          setUserName(response.data.name);
          setUserId(response.data.user_id);
          openConfirmModal();
        }else{
          const apiErrors = {upiAddress : response.data.message};
          setErrors(apiErrors);
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
    }
  }
  const transferNow = async(amount,mpin,remark) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("user_id", userId);
      formData.append("remark", remark);
      formData.append("send_amount", amount);
      formData.append("mpin", mpin);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/wallet-transfer-store', formData);
        if(response?.data?.status === 'success'){
          setUserName("");
          setUserId("");
          closeConfirmModal();
          openModal('Success');
        }else{
          const apiErrors = {mobile : response.data.message};
          setErrors(apiErrors);
        }
      } catch (err) {
        console.log('error', err);
        setModalMsg(err);
        openModal('Error');
      } finally {
        setLoading(false); // Hide loader
      }
  }

  const errorHandling = (type) => {
    const errors = {};
    if (type === 'search') {
      if (!mobile.trim()) {
        errors.mobile = 'Mobile is required';
      } else if (mobile.length !== 10) {
        errors.mobile = 'Mobile must be at least 10 digit long';
      }
    }
    return errors;
  };

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
          <Loader /> :
          <main
            className="adminuiux-content has-sidebar"
          >
            {/*mt-4*/}
            <div className="container" id="main-content">              
              {/* Zero configuration table */}
              <input type="hidden" id="mtime" />
              {/* dashboard inner */}
             <div className="midde_cont">
              <div className="container-fluid">
                <div className="row column_title">
                  <div className="col-md-12">
                    <div className="page_title d-sm-flex">
                      <h3>Wallet To Wallet</h3>
                    </div>
                  </div>
                </div>
                <div className="row row-sm">
                    <div className="col-md-6">
                      <div className="card bd-0 shadow-base adminuiux-card">
                        <div
                          className="card-header tx-medium bd-0 tx-white"
                          style={{ padding: "0.75rem 1.25rem" }}
                        >
                          Search User
                        </div>
                        {/* card-header */}
                        <div className="card-body">                                                     
                            <div className="input-group">
                                <input
                                  type="text"
                                  name="mobile"
                                  className="form-control"
                                  placeholder="Enter user mobile number"
                                  autoComplete="off"
                                  maxLength={10}
                                  value={mobile}
                                  onChange={(e) => { setMobile(e.target.value) }}
                                />
                                <div className="input-group-append" id="button-addon2">
                                  <button
                                    className="btn btn-primary waves-effect waves-light"
                                    onClick={submitHandler}
                                    >
                                    Search
                                  </button>
                                </div>
                            </div>
                              {errors.mobile && (
                                <span className="error-message">
                                  {errors.mobile}
                                </span>
                              )}
                        </div>
                        {/* card-body */}
                      </div>
                      {/* card */}
                    </div>
                  </div>
            </div>
            </div>
            {showConfirmPopUp === 1 &&
            <ConfirmBbps
                title="Details Fetch Succesfully"
                userName={userName}
                userMobile={mobile}
                transferNow={transferNow}
                closeModal={closeConfirmModal}
                isBbps="0"
            />
            }
            {showErrorSuccessModal === 1 &&
                <ErrorSuccessModal
                  title={isErrorFlag === 0 ? 'Success' : 'Error'}
                  msg={modalMsg}
                  closeModal={closeModal}
                />
              }
            </div>
          </main>
        }
      </div>
    </>
  );
}